import * as API from '~/api'
export default new API.Controller(API.DiscountModel, 'discountModel')
